import Router from 'next/router'
import PropTypes from 'prop-types'
import React from 'react'
import env from 'config/env'
import { withI18next } from 'lib/i18n/withI18next'
import { hasLocizeTranslation } from 'lib/utils/locize'
import ProductListSkeleton from 'components/product/product-list-skeleton'
import RelatedProductLayer from 'components/shared/product/product-related/related-product-layer'
import useBestsellers from 'components/shared/useSWR/useBestsellers'
import searchCopy from '../../copy'
import styles from './style.scss'

export const EMPTY_SEARCH_RESULT_REF_TYPE = 'zero_search_result'

export const SearchNoResultBestSeller = ({ t, i18n }) => {
  const {
    data: productList,
    error: productListError,
    isLoading,
    isValidating,
    retry,
  } = useBestsellers(env.TTB_CATEGORY_ID, 8)
  const isBestSellerAvailable = Array.isArray(productList) && productList.length

  if (!isBestSellerAvailable && isLoading) {
    return <ProductListSkeleton number={8} />
  }

  if (!isBestSellerAvailable) {
    return (
      <div className="search-recovery">
        <style jsx>{styles}</style>
        <p role="status">
          {searchCopy(
            t,
            i18n?.language,
            productListError ? 'unavailable' : 'empty',
          )}
        </p>
        {productListError && (
          <button
            type="button"
            disabled={isValidating}
            onClick={() => retry().catch(() => undefined)}
          >
            {searchCopy(t, i18n?.language, isValidating ? 'retrying' : 'retry')}
          </button>
        )}
      </div>
    )
  }

  return (
    <div className="best-seller-section">
      <RelatedProductLayer
        elementID="best-seller"
        products={productList}
        displayCTA
        onClick={() => Router.push('/best-sellers')}
        title={hasLocizeTranslation(
          t,
          'NO_RECENT_VIEW_BEST_SELLER_HEADER_TITLE',
          'Best Sellers',
        )}
        subTitle={hasLocizeTranslation(
          t,
          'NO_RECENT_VIEW_BEST_SELLER_SUB_TITLE',
          'Take a look before it run out',
        )}
        isPDPRelatedProduct={false}
      />
    </div>
  )
}

SearchNoResultBestSeller.propTypes = {
  t: PropTypes.func.isRequired,
  i18n: PropTypes.shape({ language: PropTypes.string }),
}

SearchNoResultBestSeller.defaultProps = { i18n: undefined }

export default withI18next()(SearchNoResultBestSeller)
